<div class="row">
  <div class="col-sm-12 plan-container">
    @if (sub) {
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <fui-heading [text]="'fender_play.subscription_title' | translate" [level]="1" fontSize="f7"></fui-heading>
          <span class="pill m-l-10 gray" [class.green]="sub.status == 'active'">{{ statusMap[sub.status]?.title || "Unknown" }}</span>
        </div>
        <a class="btn btn-secondary" target="_blank" [href]="env.fenderPlayUrl">Go to Fender Play</a>
      </div>
      @if (!loading) {
        <div class="m-t-20">
          <div class="row">
            <div class="col-4 col-lg-3">{{ "sphere.account.status" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ sub.status == "pending" ? ("fender_play.status_pending_cancellation" | translate) : statusMap[sub.status]?.title || "Unknown" }}
              @if (sub.status == "pending") {
                <br />
                <span class="t-12">{{ "fender_play.subscription_active_through" | translate: { date: (sub.trialEndDate || sub.expirationDate | date: "MMM Do, YYYY") } }}</span>
              }
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
          </div>
          <div class="row">
            <div class="col-4 col-lg-3">{{ "general.created" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ sub.createdAt | date: "MMM Do, YYYY" }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
          </div>
          <div class="row">
            <div class="col-4 col-lg-3">{{ "sphere.subscription_details.exp" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ sub.expirationDate | date: "MMM Do, YYYY" }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
          </div>
        </div>
      }
      @if (!loading && nextInvoice) {
        <div class="m-t-50">
          <fui-heading [text]="'account.your_next_invoice' | translate" [level]="3" fontSize="f5"></fui-heading>
          <div class="row">
            <div class="col-4 col-lg-3">{{ "account.payment_date" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ nextInvoice.periodStartDate | date: "MMM Do, YYYY" }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            <div class="col-4 col-lg-3">{{ "account.subtotal" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ nextInvoice.amountDue + " " + nextInvoice.currency.toUpperCase() }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            <div class="col-4 col-lg-3">{{ "account.total" | translate }}</div>
            <div class="col-8 col-lg-9">
              {{ nextInvoice.totalAmount + " " + nextInvoice.currency.toUpperCase() }}
            </div>
            <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
          </div>
        </div>
      }
      @if (!loading && pastInvoices?.length) {
        <div class="m-t-50">
          <fui-heading [text]="'sphere.account.payment_history' | translate" [level]="3" fontSize="f5"></fui-heading>
          <div class="row">
            @for (pay of pastInvoices; track pay) {
              <div class="col-4 col-lg-3">
                {{ pay.periodStartDate | date: "MMM Do, YYYY" }}
              </div>
              <div class="col-8 col-lg-9">
                <div class="d-flex justify-content-between">
                  <div>
                    <fa-icon icon="check-circle" class="c-green"></fa-icon>
                    <strong>
                      {{ pay.totalAmount + " " + pay.currency.toUpperCase() }}
                    </strong>
                  </div>
                  @if (pay.pdfUrl) {
                    <div>
                      <a class="small-btn text-nowrap" [href]="pay.pdfUrl" target="_blank">
                        <fa-icon icon="external-link"></fa-icon>
                        &nbsp; {{ "account.view_invoice" | translate }}
                      </a>
                    </div>
                  }
                </div>
              </div>
              <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
            }
          </div>
        </div>
      }
      @if (!loading && sub.cardLast4) {
        <div class="m-t-50">
          <fui-heading [text]="'account.payment_method' | translate" [level]="3" fontSize="f5"></fui-heading>
          <div class="row">
            <div class="col-12">
              {{ sub.cardType + " **** **** **** " + sub.cardLast4 }}
              <hr class="m-y-10" />
            </div>
          </div>
        </div>
      }
      @if (sub.provider == "stripe" || sub.provider == "zuora") {
        <div class="m-t-50">
          <a class="brand-btn-reverse sm m-r-10 m-b-10" target="_blank" [href]="env.fenderPlayUrl + 'plans'">{{ "fender_play.change_subscription_plan" | translate }}</a>
          <a class="brand-btn-reverse sm m-r-10 m-b-10" target="_blank" [href]="env.fenderConnectUrl + 'payment'">{{ "fender_play.change_payment_method" | translate }}</a>
          <a class="brand-btn-reverse sm m-r-10 m-b-10" target="_blank" [href]="env.fenderPlayUrl + 'redeem'">{{ "fender_play.redeem_code" | translate }}</a>
          @if (userService.subDetails.play_subscription_normalized.status == "active") {
            <div class="m-t-20">
              <a class="small-btn" [href]="env.fenderConnectUrl + 'cancel'">{{ "fender_play.cancel_auto_renew" | translate }}</a>
            </div>
          }
        </div>
      }
      @if (sub.provider == "recharge") {
        <div class="m-t-50">
          <a class="brand-btn-reverse sm m-r-10 m-b-10" href="javascript:void(0)" (click)="appService.goToFenderShop(env.shopifyAccountPageUrl)">
            {{ "fender_play.manage_subscription" | translate }}
            <fa-icon class="m-l-5" icon="external-link"></fa-icon>
          </a>
        </div>
      }
      @if (sub.provider == "apple") {
        <div class="m-t-50">
          {{ "fender_play.apple_subscription_message" | translate }}
          <br />
          <br />
          <a
            class="brand-btn-reverse sm m-r-10 m-b-10"
            target="_blank"
            href="https://play-support.fender.com/hc/en-us/articles/360004232531-If-I-subscribed-to-Fender-Play-from-an-iPhone-or-iPad-how-do-I-manage-my-subscription"
          >
            {{ "fender_play.learn_more" | translate }}
          </a>
        </div>
      }
      @if (sub.provider == "google") {
        <div class="m-t-50">
          {{ "fender_play.google_subscription_message" | translate }}
          <br />
          <br />
          <a
            class="brand-btn-reverse sm m-r-10 m-b-10"
            target="_blank"
            href="https://play-support.fender.com/hc/en-us/articles/360004232571-If-I-subscribed-to-Fender-Play-from-an-Android-device-how-do-I-manage-my-subscription"
          >
            {{ "fender_play.learn_more" | translate }}
          </a>
        </div>
      }
    }
    @if (!sub && !loading) {
      <div>
        <div class="fui-header-hero lg">
          <div>
            <div class="d-flex justify-content-center m-b-20">
              <myp-svg id="fender-play-logo" class="svg-white" width="300" height="90"></myp-svg>
            </div>
            <span class="text-center fui-heading-font t-30">{{ "fender_play.hero_tagline" | translate }}</span>
            <div class="m-t-10">
              <a class="btn btn-secondary white m-t-40" href="https://play.fender.com" target="_blank">{{ "fender_play.learn_more" | translate }}</a>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <fui-heading [text]="'fender_play.subscription_title' | translate" [level]="2" fontSize="f9"></fui-heading>
        <fui-heading [text]="'fender_play.play_your_way' | translate" [level]="4" fontSize="f5"></fui-heading>
        <p>{{ "fender_play.description_1" | translate }}</p>
        <p>{{ "fender_play.description_2" | translate }}</p>
        <p>{{ "fender_play.description_3" | translate }}</p>
        <p>{{ "fender_play.description_4" | translate }}</p>
        <p>{{ "fender_play.description_5" | translate }}</p>
        <br />
        <a class="btn btn-secondary" target="_blank" [href]="env.fenderPlayUrl">{{ "fender_play.learn_more" | translate }}</a>
      </div>
    }
  </div>
  <ngx-spinner type="line-scale-pulse-out"></ngx-spinner>
</div>
